var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"py-2",staticStyle:{"height":"52px"},attrs:{"align-center":""}},[_c('v-tooltip',{attrs:{"bottom":"","color":"primary","open-delay":"100"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('img',{staticClass:"back-button",attrs:{"src":require("@/assets/logos/WEEZIE_logo_PNI.png")},on:{"click":_vm.backToHub}})]}}])},[_vm._v(" "),_c('span',{staticStyle:{"font-size":"9px"}},[_vm._v(_vm._s(_vm.$t("BackToHub")))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20f508da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/LeftSidebar/Title.vue
// module id = null
// module chunks = 